import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { NgbDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-popup-calendar',
  templateUrl: './popup-calendar.component.html',
  styleUrls: ['./popup-calendar.component.scss'],
  providers: [NgbDatepickerConfig]
})
export class PopupCalendarComponent implements OnInit, OnDestroy {

  @Output() enviarFecha: EventEmitter<any> = new EventEmitter();
  @Input() resetearFechas: Observable<void>;
  @Input() setDate: Observable<any>;
  @Input() setMiniumDate: Observable<any>;
  @Input() disable = false;
  private subscriptions: Array<Subscription> = [];
  public modelDate: any;
  public setMinDate: Subject<any> = new Subject<any>();

  constructor() {}

  ngOnInit() {
    this.modelDate = '';
    this.subscriptions.push(
      this.resetearFechas.subscribe(() => this.limpiar()),
      this.setDate.subscribe((ev) => this.setDateFunction(ev))
    );
    if (this.setMiniumDate) {
      this.subscriptions.push(this.setMiniumDate.subscribe((ev) => this.setMinDate.next(ev)));
    }
  }

  setDateFunction(data) {
    if (data) {
      const {year, month, day} = data;
      const date = new Date(year, month - 1, day);
      this.modelDate = date;
    }
  }

  change() {
    this.enviarFecha.emit(this.modelDate);
  }

  limpiar() {
    this.modelDate = '';
  }

  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }
}
